import { useSocket } from "@folklore/socket";
import { useMemo } from "react";

const useMediaSocket = (mediaId, onMessage) => {
    const channels = useMemo(
        () => (mediaId !== null ? [`medias.${mediaId}`] : []),
        [mediaId]
    )
    useSocket(channels, {
        onMessage
    });
}

export default useMediaSocket;
